"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4581],{

/***/ 94581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2h13c.6 0 1 .4 1 1v16c0 1.7-1.3 3-3 3H5.5C3.6 22 2 20.4 2 18.5V9c0-.6.4-1 1-1h4V3c0-.6.4-1 1-1zm-4 8v8.5c0 .8.7 1.5 1.5 1.5S7 19.3 7 18.5V10H4zm15 10c.6 0 1-.4 1-1V4H9v14.5c0 .5-.1 1-.4 1.5H19zM17 9h-5c-.6 0-1-.4-1-1s.4-1 1-1h5c.6 0 1 .4 1 1s-.4 1-1 1zm-5 4h5c.6 0 1-.4 1-1s-.4-1-1-1h-5c-.6 0-1 .4-1 1s.4 1 1 1zm5 4h-5c-.6 0-1-.4-1-1s.4-1 1-1h5c.6 0 1 .4 1 1s-.4 1-1 1z"
}), "Newspaper"));


/***/ })

}]);